import { formatDate } from "@angular/common";
export class SimulationUtils {
    static defaultSimulateText = "Simulate";
    static defaultApplicantText = "Applicant";
    static defaultGroupTypeInternalText = "Internal";
    static defaultGroupTypeExternalText = "External";
    //general
    static simulateCanMoveTo = true;
    static simulateEnableEmail = true;
    static simulateEnableAutoAdvance = false;
    //recipient settings
    static simulateDisableFilter = false;
    static simulateDisableEditing = false;
    static simulateAlwaysShowFields = false;
    static simulateDisableAdd = false;
    static simulateRecipientFilterLabel = `${this.defaultSimulateText} ${this.defaultApplicantText}`;
    static simulateRecipientFilterGroupObjects = [{
            GroupType: this.defaultGroupTypeInternalText,
            GroupName: `${this.defaultSimulateText} ${this.defaultApplicantText}`
        }];
    static simulateRecipientFilter = {
        label: this.simulateRecipientFilterLabel,
        disableEditing: this.simulateDisableEditing,
        disableAdd: this.simulateDisableAdd,
        disableFilter: this.simulateDisableFilter,
        alwaysShowFields: this.simulateAlwaysShowFields,
        groupObjects: this.simulateRecipientFilterGroupObjects
    };
    // location settings
    static simulateLocationEnable = false;
    static simulateLocationLayerName = "BP_APPLICATIONPROPERTY";
    static simulateLocationDisplayField = "ErfNumber";
    static simulateLocationAddressField = "Address";
    static simulateLocation = {
        enabled: this.simulateLocationEnable,
        locationLayerName: this.simulateLocationLayerName,
        locationDisplayField: this.simulateLocationDisplayField,
        locationAddressField: this.simulateLocationAddressField,
    };
    /* STEPS */
    static simulate_GenRequestComment_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.name = `${this.defaultSimulateText} - ${stepName}`;
        stepMeta.canMoveTo = this.simulateCanMoveTo;
        stepMeta.enableEmail = this.simulateEnableEmail;
        //recipient settings
        stepMeta.recipientFilter = this.simulateRecipientFilter;
        //recipient overwrites for settings
        stepMeta.recipientFilter.disableEditing = true,
            stepMeta.recipientFilter.disableAdd = true,
            stepMeta.recipientFilter.disableFilter = false,
            stepMeta.recipientFilter.alwaysShowFields = false,
            stepMeta.recipientFilter.groupObjects = this.simulateRecipientFilterGroupObjects;
        //location settings
        stepMeta.location = this.simulateLocation;
        return stepMeta;
    }
    static simulate_GenCaptureComment_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.name = `${this.defaultSimulateText} - ${stepName}`;
        stepMeta.canMoveTo = this.simulateCanMoveTo;
        //step specific settings
        stepMeta.businessUnit = `${this.defaultSimulateText} - "BusinessUnit"`;
        stepMeta.simulate_businessUnits = [{
                value: `${this.defaultSimulateText} - "BusinessUnit"`,
                code: `${this.defaultSimulateText} - "BusinessUnit"`
            }];
        return stepMeta;
    }
    static simulate_GenStopComment_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.canMoveTo = this.simulateCanMoveTo;
        //step specific settings
        stepMeta.commentName = `${this.defaultSimulateText} - ${stepName}`;
        return stepMeta;
    }
    static simulate_GenReviewComments_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.canMoveTo = this.simulateCanMoveTo;
        return stepMeta;
    }
    static simulate_GenAssignRecipient_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.canMoveTo = this.simulateCanMoveTo;
        //recipient settings
        stepMeta.recipientFilter = this.simulateRecipientFilter;
        //recipient overwrites for settings
        stepMeta.recipientFilter.disableEditing = false,
            stepMeta.recipientFilter.disableAdd = false,
            stepMeta.recipientFilter.disableFilter = false,
            stepMeta.recipientFilter.alwaysShowFields = true,
            stepMeta.recipientFilter.groupObjects = this.simulateRecipientFilterGroupObjects;
        //step specific settings
        stepMeta.table = "TM_APPLICATION";
        stepMeta.idFieldName = "ApplicantID";
        return stepMeta;
    }
    static simulate_GenAssignRecipients_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.canMoveTo = this.simulateCanMoveTo;
        //recipient settings
        stepMeta.recipientFilter = this.simulateRecipientFilter;
        //recipient overwrites for settings
        stepMeta.recipientFilter.disableEditing = false,
            stepMeta.recipientFilter.disableAdd = false,
            stepMeta.recipientFilter.disableFilter = false,
            stepMeta.recipientFilter.alwaysShowFields = true,
            stepMeta.recipientFilter.groupObjects = this.simulateRecipientFilterGroupObjects;
        //step specific settings
        stepMeta.numberOfRequiredRecipients = 1;
        return stepMeta;
    }
    static simulate_GenAwait_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.canMoveTo = this.simulateCanMoveTo;
        //step specific settings
        stepMeta.canExtendTimeout = false;
        return stepMeta;
    }
    static simulate_GenCaptureAssessment_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.canMoveTo = this.simulateCanMoveTo;
        stepMeta.name = `${this.defaultSimulateText} - Assessment Name`;
        //recipient settings
        stepMeta.recipientFilter = this.simulateRecipientFilter;
        //recipient overwrites for settings
        stepMeta.recipientFilter.disableEditing = false,
            stepMeta.recipientFilter.disableAdd = false,
            stepMeta.recipientFilter.disableFilter = false,
            stepMeta.recipientFilter.alwaysShowFields = true,
            stepMeta.recipientFilter.groupObjects = this.simulateRecipientFilterGroupObjects;
        //step specific settings
        const simulate_AsessmentItems = [{
                assessmentItem: `${this.defaultSimulateText} Building Control`,
                assessmentDescription: `${this.defaultSimulateText} Input from Building Control`,
                assessmentInformationRequired: false
            }];
        const simulate_multipleItemOptions = [
            {
                tableName: "AFLA_ASSESSMENT",
                tableAlias: "Assessment",
                enableMultipleItems: true,
                idField: "ID",
                displayField: "Conditions",
                fields: [
                    {
                        fieldsField: "Conditions",
                        fieldsFieldAlias: "Conditions",
                        fieldsType: "Text",
                        fieldsDateOptions: []
                    },
                    {
                        fieldsField: "Department",
                        fieldsFieldAlias: "Department",
                        fieldsType: "Text",
                        fieldsDateOptions: []
                    },
                    {
                        fieldsField: "ResponsiblePerson",
                        fieldsFieldAlias: "ResponsiblePerson",
                        fieldsType: "Text",
                        fieldsDateOptions: []
                    }
                ],
                layerName: "AFLA_ASSESSMENT"
            },
        ];
        stepMeta.AssesmentItems = simulate_AsessmentItems;
        stepMeta.assessmentCategory = `${this.defaultSimulateText} test`;
        stepMeta.displayCondition = false;
        stepMeta.displayDepartment = false;
        stepMeta.displayElaborate = false;
        stepMeta.displayResponsiblePerson = false;
        stepMeta.enableRecipientSelect = false;
        stepMeta.multipleItemOptions = simulate_multipleItemOptions;
        return stepMeta;
    }
    static simulate_GenCaptureProofOfPayment_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.canMoveTo = this.simulateCanMoveTo;
        //recipient settings
        stepMeta.recipientFilter = this.simulateRecipientFilter;
        //recipient overwrites for settings
        stepMeta.recipientFilter.disableEditing = false,
            stepMeta.recipientFilter.disableAdd = false,
            stepMeta.recipientFilter.disableFilter = false,
            stepMeta.recipientFilter.alwaysShowFields = true,
            stepMeta.recipientFilter.groupObjects = this.simulateRecipientFilterGroupObjects;
        //step specific settings
        stepMeta.simulate_defaultTemplate = [{
                deleted: false,
                name: "Simulated Template",
                id: 0,
                moduleId: 0,
                type: "InvoiceTemplate"
            }];
        stepMeta.simulate_invoiceItem = [{
                category: "Simulated Template",
                id: 0,
                invoiceId: 0,
                rebate: "No",
                voteNo: "1234",
                tariff: "Simulate Tariff",
                quantity: 0,
                unitOfMeasurement: "%",
                rate: 0,
                vatexempt: "Yes",
                amount: 1,
                calculation: "Simulate",
                rebateTariffId: 0,
                minimum: "0",
                maximum: "0",
                tariffId: "0",
                manualCalculation: "Yes",
                deleted: false
            }];
        stepMeta.simulate_invoice = [{ id: 0,
                invoiceDate: formatDate(new Date(), 'yyyy-MM-dd', "en-ZA"),
                jobId: 0,
                totalExclVat: 100,
                paymentReceived: 100,
                verified: "Verified",
                verifiedUsername: "Simulate User",
                contactPersonId: 0,
                totalInclVat: 115,
                createdUsername: "Simulated User",
                paymentDue: formatDate(new Date(), 'yyyy-MM-dd', "en-ZA"),
                personResponsibleId: 0,
                clientVatnumber: 1234,
                amountPaid: 115,
                deleted: false,
                attachments: [],
                templateId: 0,
                invoiceTemplate: stepMeta.simulate_defaultTemplate,
                invoiceItems: stepMeta.simulate_invoiceItem
            }];
        return stepMeta;
    }
    static simulate_GenCaptureResult_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.canMoveTo = this.simulateCanMoveTo;
        //recipient settings
        stepMeta.recipientFilter = this.simulateRecipientFilter;
        //recipient overwrites for settings
        stepMeta.recipientFilter.disableEditing = false,
            stepMeta.recipientFilter.disableAdd = false,
            stepMeta.recipientFilter.disableFilter = false,
            stepMeta.recipientFilter.alwaysShowFields = true,
            stepMeta.recipientFilter.groupObjects = this.simulateRecipientFilterGroupObjects;
        //step specific settings
        stepMeta.simulate_resultCategories = [{
                value: "Simulated Category",
                code: "Simulated Category"
            }];
        stepMeta.simulate_resultTypes = [{
                value: "Simulated Type",
                code: "Simulated Type"
            }];
        stepMeta.simulate_resultStatuses = [{
                value: "Simulated Status",
                code: "Simulated Status"
            }];
        return stepMeta;
    }
    static simulate_GenRequestSurvey123_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.canMoveTo = this.simulateCanMoveTo;
        stepMeta.enableEmail = this.simulateEnableEmail;
        //recipient settings
        stepMeta.recipientFilter = this.simulateRecipientFilter;
        //recipient overwrites for settings
        stepMeta.recipientFilter.disableEditing = false,
            stepMeta.recipientFilter.disableAdd = false,
            stepMeta.recipientFilter.disableFilter = false,
            stepMeta.recipientFilter.alwaysShowFields = true,
            stepMeta.recipientFilter.groupObjects = this.simulateRecipientFilterGroupObjects;
        //location settings
        stepMeta.location = this.simulateLocation;
        stepMeta.location.enable = true;
        stepMeta.location.locationLayerName = "TP_APPLICATIONPROPERTY";
        stepMeta.location.locationDisplayField = "ErfNumber";
        stepMeta.location.locationAddressField = "Address";
        //step specific settings
        stepMeta.surveyName = "Simulate Survey";
        stepMeta.simulate_availableSurveys = [{
                category: "Simulate Category",
                name: "Simulate Survey",
                description: "Simulate Survey",
                url: "http://www.google.co.za",
                featureLayerUrl: "http://www.google.co.za"
            }];
        return stepMeta;
    }
    static simulate_GenSurvey123_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.canMoveTo = this.simulateCanMoveTo;
        stepMeta.enableEmail = this.simulateEnableEmail;
        //recipient settings
        stepMeta.recipientFilter = this.simulateRecipientFilter;
        //recipient overwrites for settings
        stepMeta.recipientFilter.disableEditing = false,
            stepMeta.recipientFilter.disableAdd = false,
            stepMeta.recipientFilter.disableFilter = false,
            stepMeta.recipientFilter.alwaysShowFields = true,
            stepMeta.recipientFilter.groupObjects = this.simulateRecipientFilterGroupObjects;
        //location settings
        stepMeta.location = this.simulateLocation;
        stepMeta.location.enable = true;
        stepMeta.location.locationLayerName = "TP_APPLICATIONPROPERTY";
        stepMeta.location.locationDisplayField = "ErfNumber";
        stepMeta.location.locationAddressField = "Address";
        //step specific settings
        stepMeta.surveyName = "Simulate Survey";
        stepMeta.simulate_availableSurveys = [{
                category: "Simulate Category",
                name: "Simulate Survey",
                description: "Simulate Survey",
                url: "http://www.google.co.za",
                featureLayerUrl: "http://www.google.co.za"
            }];
        return stepMeta;
    }
    static simulate_GenDocuments_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.canMoveTo = false;
        //recipient settings
        stepMeta.recipientFilter = this.simulateRecipientFilter;
        //recipient overwrites for settings
        stepMeta.recipientFilter.disableEditing = false,
            stepMeta.recipientFilter.disableAdd = false,
            stepMeta.recipientFilter.disableFilter = false,
            stepMeta.recipientFilter.alwaysShowFields = true,
            stepMeta.recipientFilter.groupObjects = this.simulateRecipientFilterGroupObjects;
        //step specific settings
        stepMeta.enableReceivedBy = true;
        stepMeta.disableAdd = false;
        stepMeta.disableDelete = false;
        stepMeta.disableEdit = false;
        stepMeta.documentType = "Simulate Test";
        stepMeta.documentRequired = false;
        return stepMeta;
    }
    static simulate_GenOpenArcGISItem_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //step specific settings
        stepMeta.itemName = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.itemCategory = `${this.defaultSimulateText}`;
        stepMeta.autoAddToken = true;
        stepMeta.defaultArcGISItems = [{
                id: 0,
                moduleId: 0,
                name: `${this.defaultSimulateText} - Item`,
                url: "http://www.google.co.za",
                category: "Test"
            }];
        return stepMeta;
    }
    static simulate_GenPlaceholder_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        return stepMeta;
    }
    static simulate_GenArchiveDocuments_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        return stepMeta;
    }
    static simulate_GenStartParallelLegs_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        return stepMeta;
    }
    static simulate_GenParallelLegConsolidator_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        return stepMeta;
    }
    static simulate_GenQuestion_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType} - ${stepName}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType} - ${stepName}`;
        return stepMeta;
    }
    static simulate_GenReceiveComms_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //recipient settings
        stepMeta.recipientFilter = this.simulateRecipientFilter;
        //recipient overwrites for settings
        stepMeta.recipientFilter.disableEditing = false,
            stepMeta.recipientFilter.disableAdd = false,
            stepMeta.recipientFilter.disableFilter = false,
            stepMeta.recipientFilter.alwaysShowFields = true,
            stepMeta.recipientFilter.groupObjects = this.simulateRecipientFilterGroupObjects;
        //step specific settings
        stepMeta.disableLinkedCommunication = true;
        stepMeta.defaultCommunicationTypeItem = [
            {
                value: `${this.defaultSimulateText} Communication Type`
            }
        ];
        return stepMeta;
    }
    static simulate_GenReport_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //step specific settings
        stepMeta.reportGroup = `${this.defaultSimulateText} - ReportGroup`;
        stepMeta.reportName = `${this.defaultSimulateText} - Report`;
        return stepMeta;
    }
    static simulate_GenRequiredDocumentsChecklist_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //step specific settings
        stepMeta.doCompleteCheck = false;
        stepMeta.defaultCheckListItems = [
            {
                id: 0,
                jobId: 0,
                name: `${this.defaultSimulateText} - CheckList Item`,
                category: `${this.defaultSimulateText} - Category`,
                complete: "Yes",
                lastChangedDate: formatDate(new Date(), 'yyyy-MM-dd', "en-ZA"),
                lastChangedUserId: 0,
                lastChangedUsername: `${this.defaultSimulateText} - User`,
                deleted: false,
            }
        ];
        return stepMeta;
    }
    static simulate_GenSendComms_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //recipient settings
        stepMeta.recipientFilter = this.simulateRecipientFilter;
        //recipient overwrites for settings
        stepMeta.recipientFilter.disableEditing = false,
            stepMeta.recipientFilter.disableAdd = false,
            stepMeta.recipientFilter.disableFilter = false,
            stepMeta.recipientFilter.alwaysShowFields = true,
            stepMeta.recipientFilter.groupObjects = this.simulateRecipientFilterGroupObjects;
        //step specific settings
        stepMeta.recipientSelector = "Selector";
        stepMeta.allowCommunicationMethodEmail = true;
        stepMeta.allowCommunicationMethodLetter = true;
        stepMeta.allowCommunicationMethodExternal = true;
        stepMeta.allowCommunicationMethodSms = false;
        stepMeta.captureExternalCommunicationDetails = true;
        stepMeta.allowAnonymousAccess = false;
        //stepMeta.daysBeforeAnonymousAccessExpiry = "";
        stepMeta.communicationType = `${this.defaultSimulateText} Communication Type`;
        stepMeta.autoSendDetails = false;
        stepMeta.communicationMethod = "Both";
        stepMeta.defaultCommunicationTypeItem = [
            {
                value: `${this.defaultSimulateText} Communication Type`
            }
        ];
        return stepMeta;
    }
    static simulate_GenSetConditions_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //step specific settings
        stepMeta.defaultConditionItem = [
            {
                id: 0,
                jobId: 0,
                conditionId: 0,
                type: "Simulate Accepted",
                condition: "Simulate Accepted",
                fulfillmentDate: null,
                selected: "No",
                deleted: false,
            }
        ];
        return stepMeta;
    }
    static simulate_GenSetFields_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //step specific settings
        const simulate_multipleItemOptions = [
            {
                enableMultipleItems: false,
            }
        ];
        stepMeta.fields = [{
                fieldsField: "Simulate Set Field",
                fieldsFieldAlias: "Simulate Set Field",
                fieldsType: "Text",
                fieldsDateOptions: []
            }];
        stepMeta.layer = "";
        stepMeta.multipleItemOptions = simulate_multipleItemOptions;
        return stepMeta;
    }
    static simulate_GenStartApplication_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        return stepMeta;
    }
    static simulate_GenStartResubmissionPeriod_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        return stepMeta;
    }
    static simulate_GenStartTimeout_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //step specific settings
        stepMeta.timeoutName = "Simulate Timeout";
        stepMeta.timeout = 0;
        stepMeta.includeSaturdays = false;
        stepMeta.includeSundays = false;
        stepMeta.includeNonWorkdays = false;
        return stepMeta;
    }
    static simulate_GenStopTimeout_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //step specific settings
        stepMeta.timeoutName = "Simulate Timeout";
        stepMeta.canExtendTimeout = false;
        stepMeta.includeSaturdays = false;
        stepMeta.includeSundays = false;
        stepMeta.includeNonWorkdays = false;
        stepMeta.simulate_defaultTimer = [{
                id: 0,
                timerType: "Simulated Timer",
                startDate: formatDate(new Date(), 'yyyy-MM-dd', "en-ZA"),
                endDate: formatDate(new Date(), 'yyyy-MM-dd', "en-ZA")
            }];
        return stepMeta;
    }
    static simulate_GenUpdateChecklist_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //step specific settings
        stepMeta.checklistName = "Simulate Update Checklist";
        return stepMeta;
    }
    static simulate_Start_Meta(stepMeta, stepType, stepName) {
        return stepMeta;
    }
    static simulate_End_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        return stepMeta;
    }
    static simulate_GenCloseout_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //step specific settings
        stepMeta.simulate_resultType = {
            value: "Simulated Result",
            code: "Simulated Result"
        };
        stepMeta.resultDateRequired = true;
        stepMeta.remarksRequired = true;
        return stepMeta;
    }
    static simulate_GenAuthorise_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //step specific settings
        stepMeta.roleList = "SimulateRole";
        stepMeta.approvalOrder = "random";
        stepMeta.successStep = "genplaceholder";
        stepMeta.failureStep = "genplaceholder";
        return stepMeta;
    }
    static simulate_CreateGrave_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //step specific settings
        stepMeta.simulate_markerCondition = [{
                value: "Simulated MarkerCondition",
                code: "Simulated MarkerCondition"
            }];
        stepMeta.simulate_markerType = [{
                value: "Simulated MarkerType",
                code: "Simulated MarkerType"
            }];
        return stepMeta;
    }
    static simulate_CreateInvoice_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //responsiblePersonRecipientFilter settings
        stepMeta.responsiblePersonRecipientFilter = this.simulateRecipientFilter;
        //responsiblePersonRecipientFilter overwrites for settings
        stepMeta.responsiblePersonRecipientFilter.disableEditing = false,
            stepMeta.responsiblePersonRecipientFilter.disableAdd = true,
            stepMeta.responsiblePersonRecipientFilter.disableFilter = true,
            stepMeta.responsiblePersonRecipientFilter.alwaysShowFields = true,
            stepMeta.responsiblePersonRecipientFilter.groupObjects = this.simulateRecipientFilterGroupObjects;
        //contactPersonRecipientFilter settings
        stepMeta.contactPersonRecipientFilter = this.simulateRecipientFilter;
        //contactPersonRecipientFilter overwrites for settings
        stepMeta.contactPersonRecipientFilter.disableEditing = false,
            stepMeta.contactPersonRecipientFilter.disableAdd = true,
            stepMeta.contactPersonRecipientFilter.disableFilter = false,
            stepMeta.contactPersonRecipientFilter.alwaysShowFields = true,
            stepMeta.contactPersonRecipientFilter.groupObjects = this.simulateRecipientFilterGroupObjects;
        //copyToResponsiblePerson settings
        stepMeta.copyToResponsiblePerson = this.simulateRecipientFilter;
        //copyToResponsiblePerson overwrites for settings
        stepMeta.copyToResponsiblePerson.groupObjects = this.simulateRecipientFilterGroupObjects;
        //step specific settings
        stepMeta.templateName = "Simulate Template";
        stepMeta.defaultDueDays = 1;
        stepMeta.minimumDueDays = 1;
        stepMeta.simulate_defaultTemplate = [{
                deleted: false,
                name: "Simulated Template",
                id: 0,
                moduleId: 0,
                type: "InvoiceTemplate"
            }];
        return stepMeta;
    }
    static simulate_SetGrave_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //step specific settings
        stepMeta.allowMultiSelect = false;
        stepMeta.assignGrave = true;
        stepMeta.nextGraveStatus = "Simulate GraveStatus";
        stepMeta.simulate_defaultGraveStatus = [{
                value: "Simulated GraveStatus",
                code: "Simulated GraveStatus"
            }];
        return stepMeta;
    }
    static simulate_VerifyInvoice_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //responsiblePersonRecipientFilter settings
        stepMeta.responsiblePersonRecipientFilter = this.simulateRecipientFilter;
        //responsiblePersonRecipientFilter overwrites for settings
        stepMeta.responsiblePersonRecipientFilter.disableEditing = false,
            stepMeta.responsiblePersonRecipientFilter.disableAdd = true,
            stepMeta.responsiblePersonRecipientFilter.disableFilter = true,
            stepMeta.responsiblePersonRecipientFilter.alwaysShowFields = true,
            stepMeta.responsiblePersonRecipientFilter.groupObjects = this.simulateRecipientFilterGroupObjects;
        //contactPersonRecipientFilter settings
        stepMeta.contactPersonRecipientFilter = this.simulateRecipientFilter;
        //contactPersonRecipientFilter overwrites for settings
        stepMeta.contactPersonRecipientFilter.disableEditing = false,
            stepMeta.contactPersonRecipientFilter.disableAdd = true,
            stepMeta.contactPersonRecipientFilter.disableFilter = false,
            stepMeta.contactPersonRecipientFilter.alwaysShowFields = true,
            stepMeta.contactPersonRecipientFilter.groupObjects = this.simulateRecipientFilterGroupObjects;
        //copyToResponsiblePerson settings
        stepMeta.copyToResponsiblePerson = this.simulateRecipientFilter;
        //copyToResponsiblePerson overwrites for settings
        stepMeta.copyToResponsiblePerson.groupObjects = this.simulateRecipientFilterGroupObjects;
        //step specific settings
        stepMeta.templateName = "Simulate Template";
        stepMeta.defaultDueDays = 1;
        stepMeta.minimumDueDays = 1;
        stepMeta.simulate_invoiceItem = [{
                category: "Simulated Template",
                id: 0,
                invoiceId: 0,
                rebate: "No",
                voteNo: "1234",
                tariff: "Simulate Tariff",
                quantity: 0,
                unitOfMeasurement: "%",
                rate: 0,
                vatexempt: "Yes",
                amount: 1,
                calculation: "1+1",
                rebateTariffId: 0,
                minimum: "0",
                maximum: "0",
                tariffId: "0",
                manualCalculation: "Yes",
                deleted: false
            }];
        stepMeta.simulate_defaultTemplate = [{
                deleted: false,
                name: "Simulated Template",
                id: 0,
                moduleId: 0,
                type: "InvoiceTemplate"
            }];
        stepMeta.simulate_invoice = [
            { id: 0,
                invoiceDate: formatDate(new Date(), 'yyyy-MM-dd', "en-ZA"),
                jobId: 0,
                totalExclVat: 100,
                paymentReceived: 100,
                verified: "Verified",
                verifiedUsername: "Simulate User",
                contactPersonId: 0,
                totalInclVat: 115,
                createdUsername: "Simulated User",
                paymentDue: formatDate(new Date(), 'yyyy-MM-dd', "en-ZA"),
                personResponsibleId: 0,
                clientVatnumber: 1234,
                amountPaid: 115,
                deleted: false,
                attachments: [],
                templateId: 0,
                invoiceTemplate: stepMeta.simulate_defaultTemplate,
                invoiceItems: stepMeta.simulate_invoiceItem,
                contactPerson: [],
                personResponsible: []
            }
        ];
        return stepMeta;
    }
    //PV
    static simulate_PvCalculateAndViewValuation_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //step specific settings
        stepMeta.enableStatusValidateOnNextStep = ["Create exception report",
            "create draft roll report",
            "Import market analysis data again",
            "Set block parameters and attributes"];
        stepMeta.acceptedValuationStatus = "Simulate Accepted";
        stepMeta.limitPropertiesTo = "Block";
        return stepMeta;
    }
    static simulate_PvCaptureAppeal_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //recipient settings
        stepMeta.recipientFilter = this.simulateRecipientFilter;
        //recipient overwrites for settings
        stepMeta.recipientFilter.disableEditing = false,
            stepMeta.recipientFilter.disableAdd = true,
            stepMeta.recipientFilter.disableFilter = true,
            stepMeta.recipientFilter.alwaysShowFields = true,
            stepMeta.recipientFilter.groupObjects = this.simulateRecipientFilterGroupObjects;
        //step specific settings
        stepMeta.simulate_attachment = [{
                id: 0,
                date: new Date(),
                deleted: false,
            }];
        return stepMeta;
    }
    static simulate_PvCaptureObjection_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //recipient settings
        stepMeta.recipientFilter = this.simulateRecipientFilter;
        //recipient overwrites for settings
        stepMeta.recipientFilter.disableEditing = false,
            stepMeta.recipientFilter.disableAdd = true,
            stepMeta.recipientFilter.disableFilter = true,
            stepMeta.recipientFilter.alwaysShowFields = true,
            stepMeta.recipientFilter.groupObjects = this.simulateRecipientFilterGroupObjects;
        //step specific settings
        stepMeta.simulate_attachment = [{
                id: 0,
                date: new Date(),
                deleted: false,
            }];
        return stepMeta;
    }
    static simulate_pvhistoricvaluecapture_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //step specific settings
        stepMeta.simulate_zones = [{
                code: "Simulate Zone",
                value: "Simulate Zone"
            }];
        return stepMeta;
    }
    static simulate_PvSurveyProperties_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        //recipient settings
        stepMeta.recipientFilter = this.simulateRecipientFilter;
        //recipient overwrites for settings
        stepMeta.recipientFilter.disableEditing = true,
            stepMeta.recipientFilter.disableAdd = true,
            stepMeta.recipientFilter.disableFilter = false,
            stepMeta.recipientFilter.alwaysShowFields = true,
            stepMeta.recipientFilter.groupObjects = this.simulateRecipientFilterGroupObjects;
        //step specific settings
        stepMeta.communicationType = "Survey";
        stepMeta.simulate_communicationTypes = [{
                code: "Survey",
                value: "Survey"
            }];
        return stepMeta;
    }
    static simulate_PvViewAppeal_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        return stepMeta;
    }
    static simulate_PvViewObjection_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        return stepMeta;
    }
    static simulate_PvFinaliseValuations_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        return stepMeta;
    }
    static simulate_PvImportMarketAnalysisData_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        return stepMeta;
    }
    static simulate_PvSetBlockParameter_Meta(stepMeta, stepType, stepName) {
        //general settings
        stepMeta.description = `${this.defaultSimulateText} - ${stepType}`;
        stepMeta.title = `${this.defaultSimulateText} - ${stepType}`;
        return stepMeta;
    }
    /* STEPS */
    /* CREATE APPLICATION */
    static simulate_Create_Application() {
        //defaults
        let defaults = {};
        defaults.simulateApplicantFilterGroupObjects = [{
                GroupType: `${this.defaultGroupTypeInternalText}`,
                GroupName: `Simulate ${this.defaultApplicantText}`
            }];
        defaults.simulateRecipientFilterGroupObjects = [{
                GroupType: `${this.defaultGroupTypeExternalText}`,
                GroupName: `${this.defaultApplicantText}`
            }];
        defaults.simulateOwnerFilterGroupObjects = [
            {
                GroupType: `${this.defaultGroupTypeExternalText}`,
                GroupName: `Owner`
            }
        ];
        defaults.simulateBusinessOwnerFilterGroupObjects = [
            {
                GroupType: `${this.defaultGroupTypeExternalText}`,
                GroupName: `BusinessOwner`
            }
        ];
        defaults.applicationType = [{
                value: `${this.defaultSimulateText} - Application Type`,
                code: `${this.defaultSimulateText} - Application Type`
            }];
        defaults.advertisingApplicationType = [{
                value: `${this.defaultSimulateText} - Permanent ApplicationType`,
                code: `${this.defaultSimulateText} - Permanent ApplicationType`
            },
            {
                value: `${this.defaultSimulateText} - Temporary ApplicationType`,
                code: `${this.defaultSimulateText} - Temporary ApplicationType`
            }];
        defaults.propertyLeaseApplicationType = [{
                value: `Lease`,
                code: `Lease`
            },
            {
                value: `Alienation`,
                code: `Alienation`
            },
            {
                value: `Acquisition`,
                code: `Acquisition`
            }];
        defaults.signType = [{
                value: `${this.defaultSimulateText} - Sign Type`,
                code: `${this.defaultSimulateText} - Sign Type`
            }];
        defaults.buildingUse = [{
                value: `${this.defaultSimulateText} - Building Use`,
                code: `${this.defaultSimulateText} - Building Use`
            }];
        defaults.sector = [{
                value: `${this.defaultSimulateText} - Sector`,
                code: `${this.defaultSimulateText} - Sector`
            }];
        defaults.estimatedBy = [{
                value: `${this.defaultSimulateText} - Estimated By`,
                code: `${this.defaultSimulateText} - Estimated By`
            }];
        defaults.externalWallsOptions = [{
                value: `${this.defaultSimulateText} - External Walls`,
                code: `${this.defaultSimulateText} - External Walls`
            }];
        defaults.internalWallsOptions = [{
                value: `${this.defaultSimulateText} - Internal Walls`,
                code: `${this.defaultSimulateText} - Internal Walls`
            }];
        defaults.roofingOptions = [{
                value: `${this.defaultSimulateText} - Roofing Options`,
                code: `${this.defaultSimulateText} - Roofing Options`
            }];
        defaults.zoneOptions = [{
                value: `${this.defaultSimulateText} - Zone Options`,
                code: `${this.defaultSimulateText} - Zone Options`
            }];
        defaults.sexTypes = [{
                value: `${this.defaultSimulateText} - Sex Types`,
                code: `${this.defaultSimulateText} - Sex Types"`
            }];
        defaults.idTypes = [{
                value: `${this.defaultSimulateText} - Id Types`,
                code: `${this.defaultSimulateText} - Id Types`
            }];
        defaults.verticalPositionTypes = [{
                value: `${this.defaultSimulateText} - Vertical Position Types`,
                code: `${this.defaultSimulateText} - Vertical Position Types`
            }];
        defaults.applicantType = [{
                value: `${this.defaultSimulateText} - Applicant Types`,
                code: `${this.defaultSimulateText} - Applicant Types`
            }];
        defaults.phases = [{
                value: `${this.defaultSimulateText} - Phases`,
                code: `${this.defaultSimulateText} - Phases`
            }];
        defaults.conventionalPrepaidOptions = [{
                value: `${this.defaultSimulateText} - Conventional Prepaid`,
                code: `${this.defaultSimulateText} - Conventional Prepaid`
            }];
        defaults.tradingGoods = [{
                value: `${this.defaultSimulateText} - Trading Goods`,
                code: `${this.defaultSimulateText} - Trading Goods`
            }];
        defaults.leaseTypes = [{
                value: `${this.defaultSimulateText} - Lease Types`,
                code: `${this.defaultSimulateText} - Lease Types`
            }];
        defaults.lesseeTypes = [{
                value: `${this.defaultSimulateText} - Lessee Types`,
                code: `${this.defaultSimulateText} - Lessee Types`
            }];
        defaults.transferType = [{
                value: `${this.defaultSimulateText} - Transfer Type`,
                code: `${this.defaultSimulateText} - Transfer Type`
            }];
        defaults.laneClosureExtentOptions = [{
                value: `${this.defaultSimulateText} - Lane Closure Extent`,
                code: `${this.defaultSimulateText} - Lane Closure Extent`
            }];
        defaults.electricalServicesOptions = [{
                value: `${this.defaultSimulateText} - Electrical Services`,
                code: `${this.defaultSimulateText} - Electrical Services`
            }];
        defaults.propertyTypeCodes = [{
                value: `${this.defaultSimulateText} - Property Type Codes`,
                code: `${this.defaultSimulateText} - Property Type Codes`
            }];
        defaults.propertyTypesOptions = [{
                value: `${this.defaultSimulateText} - Property Types Options`,
                code: `${this.defaultSimulateText} - Property Types Options`
            }];
        defaults.valuationMethodOptions = [{
                value: `${this.defaultSimulateText} - Valuation Method Options`,
                code: `${this.defaultSimulateText} - Valuation Method Options`
            }];
        defaults.valuationMethodSplitOptions = [{
                value: `${this.defaultSimulateText} - Valuation Method Split Options`,
                code: `${this.defaultSimulateText} - Valuation Method Split Options`
            }];
        defaults.valuationRollOptions = [{
                id: 0,
                moduleId: 0,
                projectCycleId: 1,
                name: "Simulate Roll",
                description: "Simulate Roll",
                fromDate: "2024-08-14T00:00:00+02:00",
                toDate: "2024-10-27T00:00:00+02:00",
                type: "Simulate Type",
                batch: false,
                parentValuationRollId: null,
                completed: false,
                deleted: false,
                projectCycle: {
                    id: 1,
                    moduleId: 0,
                    description: "Simulate Cycle",
                    fromDate: "2024-07-30T00:00:00+02:00",
                    toDate: "2024-08-06T00:00:00+02:00",
                    implementationDate: "2024-08-05T00:00:00+02:00",
                    objectionDueDate: "2024-07-31T00:00:00+02:00",
                    appealDueDate: "2024-07-31T00:00:00+02:00",
                    valuationDate: "2024-08-03T00:00:00+02:00",
                    createdUserId: 0,
                    createdDate: "2024-07-29T16:12:00+02:00",
                    lastEditedUserId: 0,
                    lastEditedDate: "2024-07-29T16:12:00+02:00",
                    deleted: false,
                    name: "Simulate Cycle",
                    completed: false,
                },
            }];
        return defaults;
    }
}
